function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#7725b9",
  className: "st0",
  d: "M119.28,33.83v44.74h-10.46v-6.91H49.94v6.91l-10.46,0V33.83h-3.6v-6.88h8.8l4.91-15.26 c1.45-4.49,3.86-8.58,8.58-8.58h44.26c4.72,0,7.44,4,8.58,8.58l3.79,15.26h8.09v6.88H119.28L119.28,33.83L119.28,33.83z M3.7,58.62 c-2.82,3.72-5.06,7.89-2.73,14.01c1.51,3.97,4.99,7.23,9.38,9.04c-7.17-15.82,13.41-21.49,14.03-2.75 c6.89-5.72,6.83-14.15,1.78-20.97c-2.38-3.22-3.58-5.03-4.1-6.89c-0.3-1.01-0.36-2.03-0.36-3.32c-0.02-4.35,0.48-8.63,0.58-13.24 c0.17-8.7,13.54-13.09,8.83-25.46C29.6,5.07,26.12,1.82,21.73,0C28.9,15.82,8.32,21.49,7.7,2.75C0.81,8.47,0.87,16.9,5.92,23.72 c2.22,2.99,4.83,4.87,4.67,10.76c-0.17,4.09-0.44,8.31-0.71,12.41c-0.1,1.63-0.26,2.71-0.66,3.74c-0.71,1.86-2.15,3.54-5.51,7.94 L3.7,58.62L3.7,58.62z M65.11,57.85h28.09v7.28l-28.09,0V57.85L65.11,57.85L65.11,57.85z M42.98,40.89 c7.87,0.25,12.69,3.55,13.92,10.42H42.98V40.89L42.98,40.89z M114.78,40.89c-7.87,0.25-12.69,3.55-13.92,10.42h13.92V40.89 L114.78,40.89z M48.43,26.95h61.89l-2.77-12.79c-0.76-3.51-2.94-6.54-6.54-6.54H59.07c-3.59,0-5.44,3.11-6.54,6.54L48.43,26.95 L48.43,26.95L48.43,26.95z"
}));

var SvgAssetDown = function SvgAssetDown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 81.68",
    style: {
      enableBackground: "new 0 0 122.88 81.68"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssetDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/asset_down.26dcac92.svg";
export { ForwardRef as ReactComponent };